module.exports = __webpack_public_path__ + "e71a2fd4fd5e74faaa3646bb79176cfd.png";